import script from "./VerificationSheet.vue?vue&type=script&setup=true&lang=ts"
export * from "./VerificationSheet.vue?vue&type=script&setup=true&lang=ts"

import "./VerificationSheet.vue?vue&type=style&index=0&id=1014bdb1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1014bdb1"]])

export default __exports__